import axios, { AxiosResponse } from "axios";
import { CommunicationRequest } from "./dtos/communication/CommunicationRequest";
import { CommunicationResponse } from "./dtos/communication/CommunicationResponse";
import { AddendumContractRequest } from "./dtos/communication/AddendumContractRequest";
import { appConfig } from "../config/keycloak";

class CommunicationService {

    private readonly api = axios.create({
        baseURL: appConfig.baseUrl
    });

    constructor() {
        // Empty constructor, configuration is in the api instance
    }

    /**
     * Dispatch communications via the communication orchestrator
     * @param token - Authorization token
     * @param request - Communication request with contacts and templates
     * @returns Promise with communication response
     */
    public dispatch(token: string, request: CommunicationRequest): Promise<AxiosResponse<CommunicationResponse>> {
        return this.api.post(
            '/communication-service/api/communications/dispatch',
            request,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Dispatch communications with contract via the communication orchestrator
     * @param token - Authorization token
     * @param request - Addendum contract request with both addendum and contract templates
     * @returns Promise with communication response
     */
    public dispatchWithContract(
        token: string,
        request: AddendumContractRequest
    ): Promise<AxiosResponse<CommunicationResponse>> {
        return this.api.post(
            '/communication-service/api/communications/addendum-contract/dispatch',
            request,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Get communication history for a specific deal
     * @param token - Authorization token
     * @param dealPrivateId - Private ID of the deal
     * @returns Promise with array of communication history
     */
    public getHistory(token: string, dealPrivateId: string): Promise<AxiosResponse<any[]>> {
        return this.api.get(
            `/communication-service/api/communications/history/${dealPrivateId}/all`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

}

export default new CommunicationService();
